import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'

const KEY = 'ssp-dev-actor-email'

/** Requester/approver switch. Hidden unless VITE_DEV_ACTOR_SWITCH=true (local Vite and the shared dev image). */
export function DevActorSwitch() {
  const queryClient = useQueryClient()
  const [email, setEmail] = useState(() => {
    try {
      return sessionStorage.getItem(KEY) ?? ''
    } catch {
      return ''
    }
  })
  if (import.meta.env.VITE_DEV_ACTOR_SWITCH !== 'true') return null

  function apply(next: string) {
    try {
      if (next) sessionStorage.setItem(KEY, next)
      else sessionStorage.removeItem(KEY)
    } catch {
      // The header is omitted and the backend keeps the default dev superuser.
    }
    setEmail(next)
    void queryClient.invalidateQueries({ queryKey: ['patching'] })
  }

  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12 }}>
      Dev actor
      <select data-testid="dev-actor-switch" value={email} onChange={(event) => apply(event.target.value)}>
        <option value="">Default requester</option>
        <option value="dev@aptean.com">Requester dev@aptean.com</option>
        <option value="dev-approver@aptean.com">DEV approver</option>
      </select>
    </label>
  )
}
